import SocialIcon, { SocialTypes } from '@components/atoms/icons/SocialIcon';
import env from '@lib/constants/env';
import ROUTES from '@lib/constants/routes';
import {
  facebookShareLink, linkedinShareLink, twitterShare, whatsAppShareLink,
} from '@lib/helpers/share';
import { trackEvent } from '@lib/services/analytics';
import { RichText } from 'prismic-reactjs';
import styled from 'styled-components';
import { Post } from 'types/frontEndTypes';

export const ShareButton = styled.a`
  background-color: transparent;
  box-shadow: 0px 0px 0px 1px #e7e7e9 inset;
  display: inline-block;
  padding: 10px 16px;
  cursor: pointer;
  border: none;
  text-decoration: none;
  transition: all 200ms ease;
  border-radius: 8px;
  appearance: none;
  position: relative;
  outline: none;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  height: 40px;
  box-sizing: border-box;
  text-align: center;

  svg {
    height: 24px;
    width: 24px;
    vertical-align: middle;
    margin-top: -3px;
  }
  :hover {
    background-color: transparent;
    box-shadow: 0px 0px 0px 1px #dbdbde inset;
  }
`;

const ShareButtons = styled.div`
  margin: 10px 0px 40px;

  a:not(:first-child) {
    margin-left: 10px;
  }
`;

const trackShare = ({ postId, to }: { postId: string; to: SocialTypes }) => {
  trackEvent('clicked on share post', {
    post: postId,
    to,
  });
};

const ShareBlogPost = ({ post }: { post: Post }) => {
  const url = `${env.baseUrl}/${ROUTES.blogPost(post.uid)}`;

  return (
    <ShareButtons>
      <ShareButton
        rel="noreferrer"
        target="_blank"
        href={whatsAppShareLink(url)}
        onClick={() => trackShare({ postId: post.uid, to: SocialTypes.facebook })}
      >
        <SocialIcon type={SocialTypes.whatsapp} color="#25D366" />
      </ShareButton>
      <ShareButton
        rel="noreferrer"
        href={facebookShareLink(url)}
        target="_blank"
        onClick={() => trackShare({ postId: post.uid, to: SocialTypes.facebook })}
      >
        <SocialIcon type={SocialTypes.facebook} color="#3b5998" />
      </ShareButton>
      <ShareButton
        onClick={() => trackShare({ postId: post.uid, to: SocialTypes.twitter })}
        href={twitterShare(
          RichText.asText(post.data.title),
          url,
        )}
        rel="noreferrer"
        target="_blank"
      >
        <SocialIcon type={SocialTypes.twitter} color="#1da1f2" />
      </ShareButton>
      <ShareButton
        onClick={() => trackShare({ postId: post.uid, to: SocialTypes.linkedin })}
        href={linkedinShareLink(url)}
        target="_blank"
        rel="noreferrer"
      >
        <SocialIcon type={SocialTypes.linkedin} color="#0077b5" />
      </ShareButton>
    </ShareButtons>
  );
};
export default ShareBlogPost;
